// extracted by mini-css-extract-plugin
export default {"page":"Page_page__2dKfq","narrow":"Page_narrow__FkrVI","wide":"Page_wide__0pjdm"};